import React from "react"
import logo from "assets/images/logo.png"
import "./styles.scss"

interface AuthLayoutProps {
	title?: React.ReactNode
	subtitle?: React.ReactNode
	children: React.ReactNode
}

function AuthLayout({ title, subtitle, children }: AuthLayoutProps) {
	return (
		<div className="AuthLayout">
			<div className="AuthLayoutCard">
				<div className="AuthLayoutCardInner">
					<div
						className={`AuthLayoutBrand${title || subtitle ? "" : " __logoOnly"}`}
					>
						<img src={logo} alt="Dingoo logo" />
						{title && <h1>{title}</h1>}
						{subtitle && <p>{subtitle}</p>}
					</div>
					{children}
				</div>
			</div>

			<p className="AuthLayoutFooter">
				&copy; {new Date().getFullYear()} Dingoo. All rights reserved.
			</p>
		</div>
	)
}

export default AuthLayout
